export default __webpack_public_path__ + "static/media/pa.a421cd20.svg";